import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import _ from 'lodash';
import NewRespondent from './NewRespondent';
import { growlErrors } from '../../../utils/NotificationUtil';
import { createRespondent } from '../../../services/apps/RespondentServices';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { ACCOUNT_QUERY, USER_AGREEMENT } from './queries';
import { Loading } from '../../../components/Loading';
import { useHistory } from "react-router-dom";

const NewRespondentContainer = () => {
  const history = useHistory();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const handleCancel = () => {
    const redirectUrl = `/accounts/${currentAccount}/respondents`;
    history.push(redirectUrl);
  }

  const saveRespondent = async (formValues, fieldsInfo) => {
    const {
      saveAndAdd,
      targetJob,
      email,
      firstName,
      lastName,
      gender,
      locale,
      notes,
      type,
      targetJobId,
      ...rest
    } = formValues;

    const restKeys = Object.keys(rest);
    const ariFieldsInput = restKeys.map((key) => {
      const tokens = _.split(key, '_');
      const fieldInfo = _.find(fieldsInfo, fi => fi.ariFieldId === tokens[1]);
      return ({
        ariFieldId: tokens[1],
        question: fieldInfo.question,
        mandatory: fieldInfo.mandatory,
        answer: formValues[key],
        ariFieldType: tokens[0] === 'global' ? 'GLOBAL' : 'LOCAL',
        ariInputType: fieldInfo.ariInputType,
        dropdownAnswers: fieldInfo.dropdownAnswers,
      });
    });

    const input = {
      firstName,
      lastName,
      email,
      notes,
      gender,
      locale,
      type,
      ariFields: ariFieldsInput,
    };

    try {
      const result = await createRespondent({
        ...input,
        targetJobId: targetJob ? targetJob.id : '',
        accountId: currentAccount,
      });
      if (!saveAndAdd) {
        const { id } = result.createRespondent.respondent;
        const redirectUrl = `/accounts/${currentAccount}/respondents/${id}`;
        history.push(redirectUrl);
      }

      return Promise.resolve();
    } catch (err) {
      growlErrors(growl, err);
      return Promise.reject();
    }
  }

  return (
    <Query query={USER_AGREEMENT} variables={{ first: 999 }}>
      {
        ({ loading: loadingAgr, error: errorAgr, data: dataAgr }) => {
          if (errorAgr) {
            growlErrors(growl, errorAgr);
          }

          if (loadingAgr) {
            return (<Loading />);
          }

          return (
            <Query query={ACCOUNT_QUERY} variables={{ accountId: currentAccount }}>
              {({ loading: loadingAcc, error: errorAcc, data: dataAcc }) => {
                if (errorAcc) {
                  growlErrors(growl, errorAcc);
                }
                if (loadingAcc) {
                  return (<Loading />);
                }

                return (
                  <NewRespondent
                    onCancel={handleCancel}
                    onSave={saveRespondent}
                    accountData={dataAcc}
                    agreementData={dataAgr}
                  />
                );
              }}
            </Query>
          );
        }
      }

    </Query>
  );
}

export default NewRespondentContainer;
